<form [formGroup]="formGroup" #formDirective="ngForm">
  <div class="row">
    <div class="col-xl-6 col-12">
      <mat-form-field class="w-100">
        <mat-label>{{ 'Public.ContactData.Prename' | translate }}</mat-label>
        <input matInput formControlName="prename" autocomplete="new-password">
        @if (formGroup.get('prename')?.hasError('required')) {
          <mat-error>
            {{ 'Public.ContactData.Validation.Required' | translate }}
          </mat-error>
        }
        @if (formGroup.get('prename')?.hasError('forbiddenCharacters')) {
          <mat-error>
              {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-xl-6 col-12">
      <mat-form-field class="w-100">
        <mat-label>{{ 'Public.ContactData.Name' | translate }}</mat-label>
        <input matInput formControlName="name" autocomplete="new-password">
        @if (formGroup.get('name')?.hasError('required')) {
          <mat-error>
            {{ 'Public.ContactData.Validation.Required' | translate }}
          </mat-error>
        }
        @if (formGroup.get('name')?.hasError('forbiddenCharacters')) {
          <mat-error>
              {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  @if (!singleBooking && !diplomatBooking) {
    <div class="row">
      <div class="col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Organization' | translate }}</mat-label>
          <input matInput formControlName="organization" autocomplete="new-password">
          @if (formGroup.get('organization')?.hasError('forbiddenCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }

  @if (diplomatBooking) {
    <div class="row">
      <div class="col-xl-6 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Mail' | translate }}</mat-label>
          <input matInput formControlName="mail" autocomplete="new-password">
          @if (hasError(mailControl, 'pattern')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.EmailPattern' | translate }}
            </mat-error>
          }
          @if (hasError(mailControl, 'required')) {
            <mat-error>
              {{ 'Common.Validation.Required' | translate }}
            </mat-error>
          }
          @if (hasError(mailControl, 'forbiddenCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }

  @if (showAddress && (!isParliamentPerson || showParliamentPersonFields)) {
    <div class="row">
      <div class="col-xl-9 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Street' | translate }}</mat-label>
          <input matInput formControlName="street" autocomplete="new-password">
          @if (formGroup.get('street')?.hasError('required')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.Required' | translate }}
            </mat-error>
          }
          @if (formGroup.get('street')?.hasError('forbiddenCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-xl-3 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Number' | translate }}</mat-label>
          <input matInput formControlName="number" autocomplete="new-password">
          @if (formGroup.get('number')?.hasError('required')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.Required' | translate }}
            </mat-error>
          }
          @if (formGroup.get('number')?.hasError('forbiddenCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }

  @if (showAddress && (!isParliamentPerson || showParliamentPersonFields)) {
    <div class="row">
      <div class="col-xl-3 col-12">
        <postal-code [postalCodeControl]="zipControl" [label]="getZipLabel() | translate" [checkBlocked]="true" (result)="updatePlace($event)"></postal-code>
      </div>
      <div class="col-xl-9 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Location' | translate }}</mat-label>
          <input matInput formControlName="location" autocomplete="new-password">
          @if (formGroup.get('location')?.hasError('required')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.Required' | translate }}
            </mat-error>
          }
          @if (formGroup.get('location')?.hasError('forbiddenLocationCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenLocationCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }

  <div class="row">
    
    @if (!showSimplest && !diplomatBooking && (!isParliamentPerson || showParliamentPersonFields)) {
      <div class="col-xl-6 col-12 mb-3">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Mobile' | translate }}</mat-label>
          <input matInput formControlName="mobile" autocomplete="new-password" placeholder="+41 79 123 45 67 / +41 58 123 45 67">
          @if (formGroup.controls.mobile.hasError('required')) {
            <mat-error>
              {{ 'Common.Validation.Required' | translate }}
            </mat-error>
          }
          @if (formGroup.controls.mobile.hasError('pattern')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.PhonePattern' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if (!showSimplest && !diplomatBooking) {
      <div class="col-xl-6 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.Mail' | translate }}</mat-label>
          <input matInput formControlName="mail" autocomplete="new-password">
          @if (hasError(mailControl, 'pattern')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.EmailPattern' | translate }}
            </mat-error>
          }
          @if (hasError(mailControl, 'required')) {
            <mat-error>
              {{ 'Common.Validation.Required' | translate }}
            </mat-error>
          }
          @if (hasError(mailControl, 'forbiddenCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (showMailToggle) {
      <div class="col-xl-6 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.LandOrganization' | translate }}</mat-label>
          <input matInput formControlName="organization" autocomplete="new-password">
          @if (formGroup.get('organization')?.hasError('forbiddenCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if (!showSimple && (!isParliamentPerson || showParliamentPersonFields)) {
      <div class="col-xl-6 col-12">
        <mat-form-field class="w-100">
          <mat-label>{{ 'Public.ContactData.IdentificationNumber' | translate }}</mat-label>
          <input matInput formControlName="identificationNumber" autocomplete="new-password">
          @if (formGroup.get('identificationNumber')?.hasError('forbiddenCharacters')) {
            <mat-error>
                {{ 'Common.Validation.HasForbiddenCharacters' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if ((!showSimple || !showSimplest) && showCorrespondenceLanguage) {
      <div class="col-12" [ngClass]="showMailToggle ? 'col-xl-3' : 'col-xl-6'">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Public.ContactData.CorrespondenceLanguage' | translate }}</mat-label>
          <mat-select panelClass="picker-options" formControlName="language">
            @for (language of languages; track language) {
              <mat-option [value]="language.languageCode">
                {{ language.name }}
              </mat-option>
            }
          </mat-select>
          @if (formGroup.get('language')?.hasError('required')) {
            <mat-error>
              {{ 'Public.ContactData.Validation.Required' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if (showMailToggle) {
      <div class="col-xl-3 col-12 pt-3">
        <mat-slide-toggle [formControl]="showMailToggleControl" (click)="mailToggleChange()">
          {{ 'Public.ContactData.SendTicketToBookingPerson' | translate}}
        </mat-slide-toggle>
      </div>
    }
  </div>
</form>
